import type { DataType, IDataObject } from '@inpart-io/devtools-iap';
import { GET_BY_ID, RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import {
    type IBookmarkable,
    type ILeadStatusConfiguration,
    type IPrivateBookmark,
    privateBookmarkProperties,
    privateBookmarksManager
} from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { useDataObjectHelper } from '@/composables/useDataObjectHelper';

export const CREATE_BOOKMARK = 'createBookmark';
export const DELETE_BOOKMARK = 'deleteBookmark';

export const actions: ActionTree<ILeadStatusConfiguration, unknown> = {
    async [CREATE_BOOKMARK](context, { id, targetType }: { id: number; targetType: string }): Promise<number | undefined> {
        const result = await privateBookmarksManager.createBookmark(id, targetType, { properties: privateBookmarkProperties.DEFAULT });

        if (result !== undefined) {
            void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
        }
        return result?.dobjId;
    },
    async [DELETE_BOOKMARK](context, { dobjId, properties }: { dobjId: number; properties?: string }): Promise<void> {
        const bookmark = context.getters[GET_BY_ID](dobjId);

        if (bookmark.target?.type !== undefined) {
            const other: IBookmarkable & IDataObject = { dobjId: bookmark.target.dobjId, bookmark: undefined };
            const dtoModule = useDataObjectHelper().getDataObjectModule(bookmark.target?.type as DataType);
            void context.dispatch(`${dtoModule}/${STORE_DATA_OBJECTS}`, { dataObjectList: [other] }, { root: true });
        }
        await privateBookmarksManager.delete(dobjId, { properties });
        context.commit(REMOVE_DATA_OBJECTS, { dobjId });
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IPrivateBookmark[] }) {
        dataObjectList.forEach((bookmark) => {
            // Update bookmark target
            if (bookmark.target?.type !== undefined) {
                const other = { dobjId: bookmark.target.dobjId, bookmark: bookmark.dobjId };
                const dtoModule = useDataObjectHelper().getDataObjectModule(bookmark.target?.type as DataType);
                void context.dispatch(`${dtoModule}/${STORE_DATA_OBJECTS}`, { dataObjectList: [other] }, { root: true });
            }
        });

        context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList });
    }
};
